// Camera diagnostics have been moved into VideoCallModal.
// Open a call → click ⚙️ → "🔬 Diagnostics" tab.
// This file is a no-op so existing imports don't break.
export default function CameraDebug() {
  return null;
}